<template>
    <div>
        <VLayout wrap class="hidden-sm-and-up">
            <VFlex xs12>
                <v-list two-line>
                    <v-list-item @click="$emit('player1',p1)">
                        <v-list-item-avatar>
                            <v-img :src="p1['profile.profilepic']" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{p1['profile.firstname']}} {{p1['profile.lastname']}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <RegData :keys="regdata" :regdata="p1.registrationdata" />
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="$emit('player2',p2)">
                        <v-list-item-avatar>
                            <v-img :src="p2['profile.profilepic']" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{p2['profile.firstname']}} {{p2['profile.lastname']}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <RegData :keys="regdata" :regdata="p2.registrationdata" />
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
            </VFlex>
        </VLayout>

        <VLayout wrap class="hidden-xs-only">
            <VFlex sm6>
                <v-list>
                    <v-list-item @click="$emit('player1',p1)">
                        <v-list-item-avatar>
                            <v-img :src="p1['profile.profilepic']" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{p1['profile.firstname']}} {{p1['profile.lastname']}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <RegData :keys="regdata" :regdata="p1.registrationdata" />
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </VFlex>
            <VFlex sm6>
                <v-list>
                    <v-list-item @click="$emit('player2',p2)">
                        <v-list-item-content>
                            <v-list-item-title>
                                <div class="text-right">
                                    {{p2['profile.firstname']}} {{p2['profile.lastname']}}
                                </div>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <div class="text-right">
                                <RegData :keys="regdata" :regdata="p2.registrationdata" />
                                </div>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-avatar>
                            <v-img :src="p2['profile.profilepic']" />
                        </v-list-item-avatar>
                    </v-list-item>

                </v-list>
            </VFlex>
            <VFlex xs12>
                <v-divider></v-divider>
            </VFlex>
        </VLayout>

    </div>
</template>

<script>
    import RegData from "./RegData";
    export default {
        props:['p1','p2','regdata'],
        components: {RegData},
        name: "DoublesCard",
        data() {
            return {
                as:50
            }
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style scoped>
    .pcborder{
        padding:4px;
        width:100%;
        max-width:400px;
        background-color: #222;
        border-top-left-radius: 25px;
        border-bottom-right-radius: 25px;
        border-top-right-radius: 25px;
    }
    .pcard{
        padding-top: 5px;
        padding-bottom: 5px;
        text-overflow: ellipsis;
        display:inline-block;
        color:white;
        font-weight: 500;
        width:100%;
        border:solid thin #ccc;
    }
    .p1{
        padding-left:3px;
        background-color:#D50000;
        border-top-left-radius: 25px;
        border-bottom-right-radius: 25px;
    }
    .p2{
        padding-right:3px;
        background-color:#2196F3;
        border-bottom-right-radius: 25px;
        border-top-right-radius: 25px;
        border-top-left-radius: 25px;
    }
</style>